document.addEventListener('DOMContentLoaded', function() {
    // Function to update the price
    function updatePrice(variant) {
        const discountedPriceElement = document.getElementById('discounted-price');
        const unitPriceElement = document.getElementById('unit-price');
        const perSpanElement = document.querySelector('.per_span');

        if (variant) {
            discountedPriceElement.textContent = `$${parseFloat(variant.discounted_price).toFixed(2)}`;
            unitPriceElement.textContent = `$${parseFloat(variant.unit_price).toFixed(2)}`;

            let uomText = '';
            switch (variant.price_uom) {
                case 'SF':
                case 'SQFT':
                    uomText = '/Sq Ft';
                    break;
                case 'PCS':
                case 'PC':
                    uomText = '/PCS';
                    break;
                case 'SH':
                case 'SHT':
                    uomText = '/Sheet';
                    break;
                default:
                    uomText = '';
            }
            perSpanElement.textContent = uomText;
        }
    }

    // Mock function to simulate variant selection change, replace with actual logic
    function simulateVariantChange() {
        // Example variant data, replace with actual variant data from your selection logic
        const variant = {
            discounted_price: 25.99,
            unit_price: 30.00,
            price_uom: 'PCS'
        };
        updatePrice(variant);
    }

    // Event listener for variant selection change
    document.querySelectorAll('input[name="option"], select[name="options"]').forEach((element) => {
        element.addEventListener('change', simulateVariantChange);
    });

    // Initial update
    simulateVariantChange();
});
